<template>
  <div class="sales-statistics">
    <el-card>
      <!-- 筛选条件 -->
      <div class="filter-section" id="filter-section">
        <div class="form-content">
          <el-form :inline="true" :model="searchForm" class="demo-form-inline">
            <el-form-item label="">
              <el-input
                v-model="searchForm.customerName"
                placeholder="请输入客户名称"
                style="width: 140px"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="订单创建时间">
              <el-date-picker
                v-model="searchForm.createTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                size="small"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="订单完成时间">
              <el-date-picker
                v-model="searchForm.completeTimeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select
                v-model="searchForm.orderStatus"
                placeholder="请选择订单状态"
                style="width: 100px"
                size="small"
              >
                <el-option
                  v-for="item in orderStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合作医药公司">
              <el-input
                v-model="searchForm.medicalCompany"
                placeholder="请输入合作医药公司"
                style="width: 160px"
                size="small"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-buttons">
          <div>
            <el-button type="primary" @click="handleSearch" size="small"
              >查询</el-button
            >
          </div>
          <div>
            <el-button @click="handleReset" size="small">重置</el-button>
          </div>
          <div>
            <el-button type="success" @click="handleExport" size="small"
              >导出</el-button
            >
          </div>
        </div>
      </div>
      <!-- 数据表格 -->
      <div class="table-section" :style="{ height: topContentHeight + 'px' }">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          v-loading="loading"
        >
          <el-table-column
            prop="clientName"
            label="客户名称"
            min-width="220"
          ></el-table-column>
          <el-table-column
            prop="clientAdministrativeRegion"
            label="客户行政区域"
            min-width="200"
          ></el-table-column>
          <el-table-column
            prop="clientAddress"
            label="客户详细地址"
            min-width="250"
          ></el-table-column>
          <el-table-column
            prop="goodsName"
            label="商品名称"
            min-width="220"
          ></el-table-column>
          <el-table-column
            prop="orderStartTime"
            label="订单创建时间"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="orderEndTime"
            label="订单完成时间"
            min-width="180"
          ></el-table-column>
          <el-table-column prop="orderStatus" label="订单状态" min-width="80">
            <template slot-scope="scope">
              <div>
                {{
                  orderStatusOptions.find(
                    (item) => item.value === scope.row.orderStatus
                  )?.label || "-"
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="medicinePrice"
            label="商品单价"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="medicineNumber"
            label="商品数量"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="saleTotalPrice"
            label="总金额"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="afterSaleTotalAmount"
            label="售后总金额"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="medicineManagerName"
            label="合作医药公司"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="drugPrice"
            label="药品单价"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="medicineNumber"
            label="药品数量"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="distributorInfo"
            label="分账方及分账金额"
            min-width="250"
          >
            <template slot-scope="scope">
              <div v-for="item in scope.row.splitInfoList" :key="item.id">
                {{ item.earnName }}：{{ item.earnAmount }}元
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="platformAmount"
            label="平台总服务费"
            min-width="100"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getSalesStatistics, exportSalesStatistics } from "@/api/statistics";

export default {
  name: "DkxSalesStatistics",
  data() {
    return {
      // 搜索条件
      searchForm: {
        customerName: "",
        createTimeRange: null,
        completeTimeRange: null,
        orderStatus: "",
        medicalCompany: "",
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页信息
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      orderStatusOptions: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待付款",
          value: "1",
        },
        {
          label: "待发货",
          value: "2",
        },
        {
          label: "配送中",
          value: "3",
        },
        {
          label: "资质待审核",
          value: "4",
        },
        {
          label: "交易取消",
          value: "5",
        },
        {
          label: "申请退款",
          value: "6",
        },
        {
          label: "已退款",
          value: "7",
        },
        {
          label: "已签收",
          value: "8",
        },
        {
          label: "已完成",
          value: "9",
        },
        // {
        //   label: "不展示订单",
        //   value: "00",
        // },
        {
          label: "订单待审核",
          value: "11",
        },
        {
          label: "待确款",
          value: "10",
        },
      ],
      orderStatusMap: {
        1: "待付款",
        2: "待发货",
        3: "配送中",
        4: "资质待审核",
        5: "交易取消",
        6: "申请退款",
        7: "已退款",
        8: "已签收",
        9: "已完成",
        "00": "不展示订单",
        11: "订单待审核",
        10: "待确款",
      },
      topContentHeight: 0,
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {
    const findNode = document.getElementById("filter-section");
    if (findNode) {
      console.log("findNode", findNode.clientHeight, window.innerHeight);//屏幕高度-顶部高度=表格高度
      // 设置高度变量
      this.topContentHeight = window.innerHeight - findNode.clientHeight - 220;
    }
  },
  methods: {
    pendParams(){
       const params = {
        current: this.pagination.currentPage,
        size: this.pagination.pageSize,
        clientName: this.searchForm.customerName,
        orderStatus: this.searchForm.orderStatus,
        medicineManagerName: this.searchForm.medicalCompany,
      };

      // 处理日期范围
      if (this.searchForm.createTimeRange) {
        params.orderStartTimeMin = this.searchForm.createTimeRange[0] + " 00:00:00";
        params.orderStartTimeMax = this.searchForm.createTimeRange[1] + " 23:59:59";
      }
      if (this.searchForm.completeTimeRange) {
        params.orderEndTimeMin = this.searchForm.completeTimeRange[0] + " 00:00:00";
        params.orderEndTimeMax = this.searchForm.completeTimeRange[1] + " 23:59:59";
      }
      return params;
    },
    // 获取数据
    fetchData() {
      // 订单状态：1.待付款,2.待发货, 3.配送中,4.资质待审核,5.交易取消, 6申请退款,7.已退款,8.已签收, 9.已完成, 00.不展示订单,11-订单待审核,10-待确款
      this.loading = true;
      const params = this.pendParams();
      getSalesStatistics(params)
        .then((res) => {
          console.log("res", res);
          const { records = [], total = 0 } = res || {};
          this.tableData = records;
          this.pagination.total = total || 0;
        })
        .catch((err) => {
          this.$message.error("获取数据失败");
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 查询
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },

    // 重置
    handleReset() {
      this.searchForm = {
        customerName: "",
        createTimeRange: null,
        completeTimeRange: null,
        orderStatus: "",
        medicalCompany: "",
      };
      this.pagination.currentPage = 1;
      this.fetchData();
    },

    // 导出
    handleExport() {
      // 导出逻辑
      const params = {
        ...this.pendParams(),
      };
      exportSalesStatistics(params);
    },

    // 分页处理
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped>
/* 高度变量 */
:root {
  --filter-section-height: 60px;
}

.filter-section {
  display: flex;
}
.form-content {
  flex: 1;
}
.form-buttons {
  width: 250px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
}
.table-section {
  overflow: auto;
}
/* 滚动条样式（与 tfOrderBill 保持一致） */
.table-section::-webkit-scrollbar,
.table-section >>> .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.table-section::-webkit-scrollbar-thumb,
.table-section >>> .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
  border-radius: 5px;
}
.table-section::-webkit-scrollbar-thumb:hover,
.table-section >>> .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}
.table-section::-webkit-scrollbar-track,
.table-section >>> .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f5f7fa;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
</style>